import { useTranslation } from 'gatsby-plugin-react-i18next';
import Link from '@components/Link';
import React from 'react';
import Title from '@atoms/Title/Title';
import './_Nav.scss';

function NavFooterSecondary(props) {
    const mod_class = ['NavFooterSecondary'].join(' ');
    const { t } = useTranslation();

    return (
        <div className={mod_class}>
            <Link
                to="/privacy/"
                className="Nav--item"
                activeClassName="is-active"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('data.privacy.title')}
                </Title>
            </Link>
            <Link
                to="/terms/"
                className="Nav--item"
                activeClassName="is-active"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('user.terms.title')}
                </Title>
            </Link>
            <Link
                to="/cookie-policy/"
                className="Nav--item"
                activeClassName="is-active"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('cookie.policy.title')}
                </Title>
            </Link>
            <Link
                to="/impressum/"
                className="Nav--item"
                activeClassName="is-active"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('legal.information.title')}
                </Title>
            </Link>
            <Link
                to="/code-of-conduct/"
                className="Nav--item"
                activeClassName="is-active"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('code.of.conduct.title')}
                </Title>
            </Link>
            <a
                href="https://drive.google.com/drive/folders/1Pq5Pwyxzc5FWY6_iuPbGVJOuXNkdqdAo?usp=drive_link"
                target="_blank"
            >
                <Title tag="span" size="xs" theme="white">
                    {t('footer.presskit')}
                </Title>
            </a>
        </div>
    );
}

export default NavFooterSecondary;
